import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { actionSuccess, actionError } from "../../../../../../../../middleware/actions/utilityAction";
import { showAlertBox } from "../../../../../../../../middleware/actions/alertBoxAction";
import ReactTooltip from "react-tooltip";
import { deleteProductDocument, fetchProductBasicById, fetchProductDocumentUrl } from "../../../../../../../../middleware/services/productApi";
import { accessRightActionCheck } from "../../../../../../../../utilities";
import ThreeDotMenu from "../../../../../../../components/threeDotMenu";
import { COMMON_ACCESS_ACTION } from "../../../../../../../../constants";
import { useHistory } from "react-router-dom";
import { setProductDetails } from "middleware/actions/productAction";
import { Box } from "@mui/material";

const DocumentTable = (props) => {
  const { accessRights: aR, productId } = props;
  const dispatch = useDispatch();
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);
  const [sortedDocumentsList, setSortedDocumentsList] = useState([]);
  const history = useHistory();
  const split_url = props.location.pathname.split("/");
  split_url.pop();

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = "Overview";
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, []);

  /* Common access */
  const accessPermissionEdit = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.EDIT_DOCUMENTS);
  const accessPermissionDelete = interfaceActionAccess?.includes(COMMON_ACCESS_ACTION.DELETE_DOCUMENTS);

  const getProductDetails = async () => {
    try {
      const response = await fetchProductBasicById(productId);
      if (response?.data?.data) dispatch(setProductDetails(response.data.data));
    } catch (error) {
      dispatch(actionError("Something Went Wrong while processing."));
    }
  };

  const handleDeleteDocument = async (id) => {
    dispatch(
      showAlertBox({
        okCallback: () => {
          (async () => {
            try {
              await deleteProductDocument(productId, id);
              dispatch(actionSuccess("Document deleted Successfully."));
              getProductDetails();
            } catch (error) {
              dispatch(actionError(error?.data?.message || "Something went wrong."));
            }
          })();
        },
      })
    );
  };

  // Sort documentsList by latest modified or created date (descending)
  useEffect(() => {
    const sortedList = (props?.documentsList || []).slice().sort((a, b) => {
      const dateA = new Date(a?.docModifiedDate || a?.docCreatedDate);
      const dateB = new Date(b?.docModifiedDate || b?.docCreatedDate);
      return dateB - dateA;
    });
    setSortedDocumentsList(sortedList);
  }, [props?.documentsList]);

  // Rebuild tooltips when data changes
  useEffect(() => {
    ReactTooltip.rebuild();
  }, [sortedDocumentsList]);

  return (
    <Box>
      {sortedDocumentsList?.length > 0 && (
        <table className="normal-table table border mb-0" style={{ tableLayout: "fixed" }}>
          <thead className="internal-grid">
            <tr>
              <th style={{ width: "20%" }}>Name</th>
              <th style={{ width: "30%" }}>Description</th>
              <th style={{ width: "45%" }}>Documents / Brochure</th>
              <th className="internal-grid-action text-center" style={{ borderLeft: "1px solid #dee2e6", width: "5%" }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedDocumentsList.map((item) => {
              const cleanDescription = item.docDescription.replace(/(<([^>]+)>|&nbsp;)/gi, "");
              return (
                <tr key={`prod-doc-${item.id}`}>
                  <td
                    style={{
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "0",
                    }}
                  >
                    {item.docTitle}
                  </td>
                  <td
                    style={{
                      maxWidth: "0",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    data-tip={cleanDescription}
                    data-for={`desc-tooltip-${item.id}`}
                  >
                    {cleanDescription}
                    <ReactTooltip id={`desc-tooltip-${item.id}`} effect="solid" place="top" multiline={true} className="custom-tooltip" />
                  </td>
                  <td
                    style={{
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "0",
                    }}
                  >
                    <a
                      href={fetchProductDocumentUrl(item.docFileName, item.docName)}
                      download
                      target="_blank"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                        maxWidth: "100%",
                      }}
                    >
                      <img src="/assets/download-icon.svg" alt="image-download" />
                      <span
                        style={{
                          wordWrap: "break-word",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.docName}
                      </span>
                    </a>
                  </td>
                  <td className="text-center" style={{ borderLeft: "1px solid #dee2e6" }}>
                    {accessPermissionEdit || accessPermissionDelete ? (
                      <ThreeDotMenu
                        rowID={item.id}
                        Edit={
                          accessPermissionEdit
                            ? () => {
                                setTimeout(() => {
                                  history.push(`${split_url.join("/")}/document/${item.id}/edit#overview`, {
                                    companyId: props?.companyId,
                                    productId: productId,
                                    documentId: item.id,
                                  });
                                }, 10);
                              }
                            : undefined
                        }
                        Delete={
                          accessPermissionDelete
                            ? () => {
                                handleDeleteDocument(item.id);
                              }
                            : undefined
                        }
                      />
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Box>
  );
};
export default DocumentTable;
DocumentTable.propTypes = {
  companyId: PropTypes.string,
  productId: PropTypes.string,
  accessRights: PropTypes.arrayOf(PropTypes.string),
};
